import { ParentGridServices, TitleContainer, SeoContainer } from "./styles";
import { Currency } from "./components";
import { useContext } from "react";
import TemplateContext from "@/context/Template/TemplateContext";

const Currencies = () => {

  const dataContext = useContext(TemplateContext);
  const { content: formatContent, ...rest } = dataContext || {};
  const { data } = rest?.properties?.service;

  const { coin, currency, usdBlueTourist } = data;

  const getNegative = (value) => {
    if (value.indexOf("-") > -1) {
      return <p className="value variation-negative dotted-border">{value}%</p>;
    }
  };

  return (
    <ParentGridServices>
      <TitleContainer>
        <h1 className="title">{`Cotización y precio del ${coin.name}`}</h1>
      </TitleContainer>
      <SeoContainer>
        <h2 className="subtitle">{`Seguí en vivo la cotización del ${coin.name}. Cómo está el precio del ${coin.name} para poder comprar y vender`}</h2>
      </SeoContainer>
      <div className="currency-container">
        <div className="currency-body">
          <div className="currency-content first ">
            <p>Monedas</p>
            <p className="value currency-name">{coin.name}</p>
          </div>
          <div className="currency-content dotted-border second">
            <p className="">Compra</p>
            <p className="value currency-buy dotted-border">
              ${coin?.buyingRate && coin.buyingRate}
            </p>
          </div>
          <div className="currency-content dotted-border">
            <p className="">Venta</p>
            <p className="value currency-sale dotted-border">
              ${coin?.sellingRate && coin.sellingRate}
            </p>
          </div>
          <div className="currency-content dotted-border">
            <p className="">Valor anterior</p>
            <p className="value previous-value dotted-border">
              ${coin?.last && coin.last}
            </p>
          </div>
          <div className="currency-content dotted-border">
            <p className="">Variación</p>
            {coin?.variation && getNegative(coin.variation)}
          </div>
        </div>
      </div>
      <Currency
        data={currency}
        usdBlueTourist={usdBlueTourist}
        title="Otros tipos de dólar"
        className="detail"
      />
    </ParentGridServices>
  );
};
export default Currencies;
